import React, { useState, useEffect } from 'react';
import ToastPanel from 'ff/debrief/layouts/ToastPanel';
import CheckIcon from '@mui/icons-material/Check';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { useCurrentDebrief } from 'ff/debrief/hooks';

const ProcessingStatusToast = () => {
    const { isProcessing, isPending, isCompleted, isError } =
        useCurrentDebrief();

    // We only want to show the success alert immediately after the re-analysis alert
    const [wasProcessing, setWasProcessing] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);

    useEffect(() => {
        if (isProcessing || isPending) {
            setWasProcessing(true);
        } else if (wasProcessing && isCompleted && !isError) {
            setShowSuccessAlert(true);
            setWasProcessing(false);
        }
    }, [isProcessing, isPending, isCompleted, isError]);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (showSuccessAlert) {
            timeout = setTimeout(() => {
                setShowSuccessAlert(false);
            }, 5000);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [showSuccessAlert]);

    return (
        <ToastPanel>
            {(isProcessing || isPending) && (
                <Alert icon={<CircularProgress size={16} />} severity="info">
                    Re-analyzing
                </Alert>
            )}

            {showSuccessAlert && (
                <Alert icon={<CheckIcon />} severity="success">
                    Success!
                </Alert>
            )}
        </ToastPanel>
    );
};

export default ProcessingStatusToast;
